import React from 'react'
import PropTypes from 'prop-types'
import { kebabCase } from 'lodash'
import { Link } from 'gatsby'
import Content from '../Content'
import ScrollPercentage from '../shared/ScrollPercentage'
import Reactions from './Reactions'

const BlogPost = ({
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
  readTime,
  id,
  url,
}) => {
  const PostContent = contentComponent || Content

  return (
    <section className="section">
      {helmet || ''}
      <div className="container content">
        <div className="columns">
          <ScrollPercentage readTime={readTime} />
          <div className="column is-10">
            <h1
              style={{ lineHeight: 1.5 }}
              className="title is-size-2 has-text-weight-bold is-bold-light"
            >
              {title}
            </h1>
            <p>{description}</p>
            <PostContent content={content} />
            <Reactions id={id} url={url} />
            {tags && tags.length ? (
              <div style={{ marginTop: `4rem` }}>
                <h4>Tags</h4>
                <ul className="taglist">
                  {tags.map((tag) => (
                    <li key={tag + `tag`}>
                      <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

BlogPost.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
  readTime: PropTypes.number,
  id: PropTypes.string,
  url: PropTypes.string,
}

export default BlogPost
